import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase.ts";
import { type AdminUser } from "./adminUserModel.ts";
import { mutate } from "swr";

interface Request {}

interface Response {
  success: boolean;
  user: AdminUser;
}

export const swrKey = "admin_getAdminUser";

export const adminUserFetcher = async () => {
  const functions = getFirebaseFunctions();
  const getUserFunction = httpsCallable<Request, Response, object>(
    functions,
    swrKey,
  );
  const res = await getUserFunction();
  return res.data.user;
};

export const swrOption = {
  onError: async (error: any) => {
    if (error.status === 401) {
      await mutate(swrKey, undefined, false);
    }
  },
  shouldRetryOnError: (error: any) => error.status !== 401,
};
